/**
 * @file: PlatformUserLoginType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum PlatformUserLoginType {
  Email = 'email',
  Mobile = 'mobile',
  UserName = 'username',
  Weixin = 'weixin',
  Wecom = 'wecom',
  AppleSignIn = 'apple_signin',
}

export const PlatformUserLoginTypeValueSet = new Set([
  PlatformUserLoginType.Email,
  PlatformUserLoginType.Mobile,
  PlatformUserLoginType.UserName,
  PlatformUserLoginType.Weixin,
  PlatformUserLoginType.Wecom,
  PlatformUserLoginType.AppleSignIn,
]);
